<template>
  <div class="settings">
    <Breadcrumbs :items="breadcrumbs">
      <rp-button type="primary" @click="openAddLanguage">Add Language</rp-button>
    </Breadcrumbs>

    <rp-table
      name="languages"
      :results="getLanguages"
      noPagination
      :key="tableState"
      :headings="['language', {heading: 'locale', key: 'code'}, {heading: 'last updated', key: 'updated'}, {heading: 'edit', key: 'edit', button: true}]">
      <div
        v-for="(locale, index) in data"
        :key="index"
        :slot="'td-' + index + '-edit'">
        <span
        @click="openUpdateLanguage(locale)">
          <rp-sprite class="create-icon" name="create"/>
        </span>
      </div>
    </rp-table>

    <rp-overlay :active="isCreateFormOpen">
      <rp-language-form
        @close="closeAddLanguage"
        :isCreateForm="true"
        v-model="newLanguage"/>
    </rp-overlay>

    <rp-overlay :active="isUpdateFormOpen">
      <rp-language-form
        @close="closeUpdateLanguage"
        :isCreateForm="false"
        v-model="updateLanguage"/>
    </rp-overlay>

  </div>
</template>

<script>
import page from '@/mixins/page'
import {mapGetters} from 'vuex'

import Overlay from 'raypro_ui/src/components/ui/Overlay'
import Breadcrumbs from '@/components/Breadcrumbs'
import Button from 'raypro_ui/src/components/ui/inputs/Button'
import Table from 'raypro_ui/src/components/ui/Table'
import Sprite from 'raypro_ui/src/components/ui/Sprite'
import LanguageForm from 'raypro_ui/src/components/ui/forms/Language'

import {getLanguages} from 'raypro_ui/src/api/languages'

export default {
  components: {
    'rp-button': Button,
    'rp-table': Table,
    'rp-overlay': Overlay,
    'rp-sprite': Sprite,
    'rp-language-form': LanguageForm,
    Breadcrumbs
  },

  mixins: [page],

  computed: {
    ...mapGetters([
      'authUser'
    ])
  },

  data() {
    return {
      title: 'Manage Languages',
      breadcrumbs: [
        {label: 'Manage Languages'}
      ],
      isCreateFormOpen: false,
      isUpdateFormOpen: false,
      newLanguage: {
        name: '',
        code: '',
        file: null
      },
      updateLanguage: {},
      data: {},
      tableState: 0,
      months: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
    }
  },

  methods: {
    openAddLanguage() {
      this.isCreateFormOpen = true
    },

    closeAddLanguage(shouldRefreshTable) {
      this.isCreateFormOpen = false
      if(shouldRefreshTable) { this.tableState++ }
    },

    openUpdateLanguage(locale) {
      this.updateLanguage = {
        name: locale.language,
        id: locale.id,
        code: locale.code,
        file: null
      }
      this.isUpdateFormOpen = true
    },

    closeUpdateLanguage(shouldRefreshTable) {
      this.isUpdateFormOpen = false
      if(shouldRefreshTable) { this.tableState++ }
    },

    getLanguages() {
      return getLanguages().then((res) => {
        const mapped = res.data.map((row) => {
          const date = new Date(row.updated_at)

          return {
            id: row.id,
            code: row.code,
            language: row.name,
            updated: `${date.getDate()} ${this.months[date.getMonth()].toUpperCase()} ${date.getFullYear()}`
          }
        })

        this.data = mapped

        return {data: mapped}
      })
    }

  }
}
</script>

<style lang="sass" scoped>
  @import 'raypro_ui/src/styles/main.sass'
  @import '../../../stylesheets/helpers/mixins'

  .breadcrumbs

    .right-items
      flex-basis: auto

      button
        margin-left: auto
        margin-right: 0

  .settings
    .create-icon
      fill: $color-primary
</style>



// WEBPACK FOOTER //
// src/components/pages/Settings/ManageLanguages.vue